import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { storeCampaignR } from 'actions/ListActions';
import { newEditionR, setVariables } from 'actions/CampaignActions';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import CampaignSettings from 'components/layout/campaigns/CampaignSettings';
import Modal from 'components/Modal';
import { confirmAlert } from 'react-confirm-alert';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import { parseQs } from 'helpers/http';
import ListFilterReset from 'components/layout/list/ListFilterReset';
import ListSpecial from 'components/ListSpecial';
import may from 'js/security';
import { ROLE_SUPERADMIN, ROLE_WL_ADMIN, ROLE_ROOT_EMPLOYEE } from 'js/constants';
import List from 'components/List';
import Archives from 'components/layout/archive/Archives';
import Edition from './Edition';
import CampaignListEntry from './CampaignListEntry';
import Tabs from '../Tabs';
import SubmissionsList from "components/layout/campaigns/SubmissionsList";

class CampaignList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSettings: false,
      modalData: null,
      deleting: false,
      action: 'new',
      showListPlaceholder: false,
      isWantInitialFetch: false,
      urlFilterOption: 'default',
    };
  }

  newEdition = (campaignId, action = '', editionId = '') => {
    this.setState({
      generatingEdition: true,
    });

    const { newEditionR } = this.props;
    let params;
    if (action === 'copy') {
      params = {
        id: editionId,
        action: 'copy',
      };
    }
    newEditionR(params);
  };

  // change the url to display order information
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  showSettings = (i, action) => {
    const { list } = this.props;
    let modalData = [];
    if (action === 'edit') {
      modalData = list.data.list[i];
    }
    this.setState({
      showSettings: true,
      modalData,
      action,
    });
  };

  closeSettings = () => {
    this.setState({
      showSettings: false,
      modalData: null,
    });
  };

  renewList = () => {
    this.forceUpdate();
  };

  handleRemoveClick = (e, campaignId) => {
    const { deleteCampaign } = this.props;

    e.preventDefault();
    e.stopPropagation();

    deleteCampaign(campaignId, 'toTrash');
    this.setState({
      showSettings: false,
      modalData: null,
    });
  };

  handleRemoveEditionClick = (e, editionId) => {
    const { deleteEdition } = this.props;

    e.preventDefault();
    e.stopPropagation();

    deleteEdition(editionId);
  };

  setUrlFilterOption = option => {
    this.setState({ urlFilterOption: option });
  };

  setUrlData = option => {
    const { location } = this.props;
    const { owner } = parseQs(location.search);
    // default same as option === default
    let urlData = {
      filters: { owner },
    };
    if (option === undefined) {
      urlData = {
        filters: {
          owner: undefined,
        },
      };
    } else if (option === 'root') {
      urlData = {
        filters: {
          owner: ['CreacheckAdmin'],
        },
      };
    }
    return urlData;
  };


  getTabContentList = (
    campaignOutput,
    campaignOutputOwn,
    campaignOutputMarked,
    markedDisable,
    recentDisable,
    markedCampaigns,
    sharedDisable
  ) => {
    const result = [];
    const {
      intl: { messages },
      appIntl,
      history,
      list,
      location,
    } = this.props;

    result.push(
      <div>
        <div id="campaignNew">
          <Button bsStyle="default" className="new-ce" bsSize="small" onClick={() => this.showSettings(0, 'new')}>
            <i className="fas fa-plus bg-green" />
            <span>{messages.campaign.new}</span>
          </Button>
        </div>
        {campaignOutput}
      </div>
    );
    result.push(
      <div>
        <div id="campaignNew">
          <div />
          <Button bsStyle="default" className="new-ce" bsSize="small" onClick={() => this.showSettings(0, 'new')}>
            <i className="fas fa-plus bg-green" />
            <span>{messages.campaign.new}</span>
          </Button>
        </div>
        {campaignOutputOwn}
      </div>
    );

    if (!markedCampaigns) {
      result.push(
        <div>
          <div id="campaignNew" />
          {campaignOutputMarked}
        </div>
      );
    }
    result.push(
      <div>
        <div id="archivedCampaigns">
          <Archives urlData={this.setUrlData(this.state.urlFilterOption)} />
        </div>
      </div>
    );

    if (!recentDisable) {
      result.push(
        <div className="editions">
          <div />
          {list.data.r_edition.length === 0 ? (
            <p>{messages.campaign.no_edition}</p>
          ) : (
            list.data.r_edition.map(rEdition => {
              return (
                <Edition
                  key={rEdition.id}
                  edition={rEdition}
                  messages={messages}
                  appIntl={appIntl}
                  history={history}
                  forceUpdate={this.forceUpdate}
                  deleter={this.handleRemoveEditionClick}
                  markOption="recent"
                  copyEdition={this.newEdition}
                />
              );
            })
          )}
        </div>
      );
    }

    if (!markedDisable) {
      result.push(
        <div className="editions">
          <div />
          {list.data.m_edition.length === 0 ? (
            <p>{messages.campaign.no_edition}</p>
          ) : (
            list.data.m_edition.map(mEdition => {
              return (
                <Edition
                  key={mEdition.id}
                  edition={mEdition}
                  messages={messages}
                  appIntl={appIntl}
                  history={history}
                  forceUpdate={this.forceUpdate}
                  deleter={this.handleRemoveEditionClick}
                  markOption="marked"
                  copyEdition={this.newEdition}
                />
              );
            })
          )}
        </div>
      );
    }

    if (!sharedDisable) {
      result.push(
        <div className="editions">
          <div />
          {list.data.s_edition.length === 0 ? (
            <p>{messages.campaign.no_edition}</p>
          ) : (
            list.data.s_edition.map(sEdition => {
              return (
                <Edition
                  key={sEdition.id}
                  edition={sEdition}
                  messages={messages}
                  appIntl={appIntl}
                  history={history}
                  forceUpdate={this.forceUpdate}
                  deleter={this.handleRemoveEditionClick}
                  markOption="shared"
                  copyEdition={this.newEdition}
                />
              );
            })
          )}
        </div>
      );
    }
    if (may('ROLE_WL_ADMIN', this.props.user.roles)) {
      result.push(
        <div>
          <div id="submissionsList">
            <SubmissionsList urlData={this.setUrlData(this.state.urlFilterOption)}/>
          </div>
        </div>
      );
    }

    return result;
  };

  getTabHeaderList = (markedDisable, recentDisable, markedCampaigns, sharedDisable) => {
    const {
      intl: { messages },
    } = this.props;
    const result = [];
    result.push(messages.meta.campaigns.name);
    result.push(messages.campaign.own_campaigns);
    if (!markedCampaigns) {
      result.push(messages.campaign.marked_campaigns);
    }
    result.push(messages.archived_campaigns);
    if (!recentDisable) {
      result.push(messages.campaign.recent_editions);
    }
    if (!markedDisable) {
      result.push(messages.campaign.marked_editions);
    }
    if (!sharedDisable) {
      result.push(messages.campaign.shared_editions);
    }

    if (may('ROLE_WL_ADMIN', this.props.user.roles)) {
      result.push(messages.campaign.submissions);
    }
    return result;
  };

  componentDidMount = () => {
    const {
      location: { search },
    } = this.props;
    const { owner: { length = 0 } = {} } = parseQs(search);
    if (length > 0) {
      this.setState({ isWantInitialFetch: true }, () => {
        this.forceUpdate();
      });
    }
    this.setUrlData('default');
  };

  componentDidUpdate = (prevProps, prevState) => {
    const {
      intl: { messages },
      pendingArchive,
      history,
      appIntl,
      forwardingR,
      setVariables,
      list: { pending },
    } = this.props;

    const {
      list: { pending: prevPending },
    } = prevProps;

    if (prevPending && !pending) {
      this.setState({ showListPlaceholder: false });
    }

    if (prevProps.pendingArchive !== pendingArchive && pendingArchive === false) {
      const options = {
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>{messages.campaign.successfully_archived}</h1>
              <p>{messages.campaign.campaign_archived}</p>
              <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                <Button
                  style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                  bsStyle="info"
                  onClick={onClose}
                >
                  OK
                </Button>
              </div>
            </div>
          );
        },
        childrenElement: () => <div />,
        closeOnEscape: true,
        closeOnClickOutside: true,
      };
      confirmAlert(options);
    }
    if (forwardingR !== prevProps.forwardingR) {
      setVariables('forwardingfalse');
      history.push(appIntl.urlPrefix + 'editor/' + forwardingR);
      window.location.reload(false);
    }
    if (prevState.urlFilterOption !== this.state.urlFilterOption) {
      this.setUrlData(this.state.urlFilterOption);
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      history,
      user,
      storeCampaignR,
      list,
    } = this.props;

    const {
      showSettings,
      modalData,
      deleting,
      action,
      generatingEdition,
      showListPlaceholder,
      isWantInitialFetch,
    } = this.state;

    const campaignOutput = [];
    const campaignOutputOwn = [];
    const campaignOutputMarked = [];

    let markedDisable = true;
    let recentDisable = true;
    let sharedDisable = true;

    if (!list.pending && list?.data?.m_edition !== undefined) {
      markedDisable = list?.data?.m_edition.length === 0;
    }

    if (!list.pending && list?.data?.r_edition !== undefined) {
      recentDisable = list?.data?.r_edition.length === 0;
    }

    if (!list.pending && list?.data?.s_edition !== undefined) {
      sharedDisable = list?.data?.s_edition.length === 0;
    }

    let markedCampaigns = true;
    const filters = [];
    filters.push(<ListFilterCompany key="owner" paramName="owner" />);
    filters.push(<ListFilterReset key="reset-all" availableFilters={['owner']} />);

    for (let i = 0; i < list.data.list.length; i++) {
      const listItem = list.data.list[i];
      campaignOutput.push(
        <CampaignListEntry
          key={listItem.id}
          campaign={listItem}
          messages={messages}
          index={i}
          showDetails={this.showDetails}
          showSettings={this.showSettings}
          deleting={deleting}
          user={user}
          appIntl={appIntl}
          history={history}
          handleRemoveClick={this.handleRemoveClick}
        />
      );

      if (typeof listItem.creator !== 'undefined' && listItem.creator) {
        if (user.username === listItem.creator.username) {
          campaignOutputOwn.push(
            <CampaignListEntry
              key={listItem.id}
              campaign={listItem}
              messages={messages}
              index={i}
              showDetails={this.showDetails}
              showSettings={this.showSettings}
              deleting={deleting}
              user={user}
              appIntl={appIntl}
              history={history}
              handleRemoveClick={this.handleRemoveClick}
            />
          );
        }
      }

      if (listItem.marked === true) {
        campaignOutputMarked.push(
          <CampaignListEntry
            key={listItem.id}
            campaign={listItem}
            messages={messages}
            index={i}
            showDetails={this.showDetails}
            showSettings={this.showSettings}
            deleting={deleting}
            user={user}
            appIntl={appIntl}
            history={history}
            handleRemoveClick={this.handleRemoveClick}
          />
        );
        markedCampaigns = false;
      }
    }
    const resultList =
      list.pending || generatingEdition ? (
        showListPlaceholder ? (
          <h4 style={{ textAlign: 'center' }}>{messages.campaign.choose_company_to_load_campaign}</h4>
        ) : (
          <Loader />
        )
      ) : (
        <div id="campaigns">
          <Tabs
            tabs={this.getTabHeaderList(markedDisable, recentDisable, markedCampaigns, sharedDisable)}
            tabContent={this.getTabContentList(
              campaignOutput,
              campaignOutputOwn,
              campaignOutputMarked,
              markedDisable,
              recentDisable,
              markedCampaigns,
              sharedDisable
            )}
            keepMounted={[0, 1]}
          />
        </div>
      );

    return (
      <div className="padding-25 sm-padding-10">
        {showSettings && (
          <Modal show={showSettings} className="creacheck-modal" onHide={() => this.closeSettings()} bsSize="lg">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <CampaignSettings
                campaign={modalData}
                closeSettings={this.closeSettings}
                messages={messages}
                renewList={this.renewList}
                action={action}
                history={history}
                deleter={this.handleRemoveClick}
                user={user}
                storeCampaignR={storeCampaignR}
                showSettingsAbout="campaignList"
              />
            </Modal.Body>
          </Modal>
        )}

        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: appIntl.urlPrefix + 'account/campaigns', name: messages.meta.campaigns.name },
          ]}
          className="p-t-0"
        />

        {may(ROLE_SUPERADMIN, user.roles) || may(ROLE_WL_ADMIN, user.roles) || may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
          <ListSpecial
            listName="campaigns"
            title={messages.meta.campaigns.name}
            url="/api/campaigns.json" //
            list={list}
            urlData={this.setUrlData('default')}
            setUrlData={this.setUrlData}
            setUrlFilterOption={this.setUrlFilterOption}
            filters={filters}
            showSearch
            showPagination={false}
            isWantInitialFetch={isWantInitialFetch}
          />
        ) : (
          <List listName="campaigns" url="/api/campaigns.json"  title={messages.meta.campaigns.name} showSearch showSearchLabel={messages.search_campaign} showPagination={false} list={list} urlData={{ filters: {} }} />
        )}

        {resultList}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.campaigns,
    user: state.login.user,
    client: state.selectedClient.company,
    pendingArchive: state.list.campaigns.pendingArchive,
    forwardingR: state.campaigns.forwardingR,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteCampaign: (campaignId, flagOption) => {
      // deleterDispatchHelper('campaign', '/api/campaigns/' + campaignId + '.json', dispatch);
      deleterDispatchHelper('campaign', '/api/news/' + campaignId + '/campaigns/' + flagOption + '.json', dispatch);
    },
    deleteEdition: editionId => {
      deleterDispatchHelper('edition', '/api/editions/' + editionId + '.json', dispatch);
    },
    storeCampaignR: (campaignId, option) => {
      dispatch(storeCampaignR(campaignId, option));
    },
    newEditionR: data => {
      dispatch(newEditionR(data));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CampaignList)
  )
);
